// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__mPJqp","spinner":"Loader_spinner__yZ2gX","spinner-d3wgkg":"Loader_spinner-d3wgkg__BRDvn"};